<template>
    <h1>{{$t("faq.pageTitle")}}</h1>

    <div class="grid">
        <div class="col-6">
            <Guide v-for="guide in guides" :key="guide.key" :guide-info="guide"></Guide>
        </div>
        <div class="col-6">
            <Question v-for="faq in faqs" :key="faq.key" :faq-info="faq" />
        </div>
    </div>

</template>
<script>
import Guide from '../components/faqs/Guide.vue';
import Question from '../components/faqs/Question.vue';
import FaqService from '../service/FaqService';
export default {
    components:{
        Guide,
        Question
    },
    data(){
        return{
            guides: [],
            faqs: []
        }
    },
    computed: {
        access_token: function() {
            return this.$store.getters["userdata/getAccessToken"];
        },
        locale: function() {
            return this.$store.getters["preferences/locale"];
        }
    },
    watch:{
        async locale(){
            this.guides = [];
            this.faqs = [];
            await this.getFaqs();
        }
    },
    created(){
        this.faqService = new FaqService();
    },
    async mounted(){
        await this.getFaqs();
    },
    methods:{
        async getFaqs(){
            let articles = await this.faqService.getFaqs(this.access_token, this.locale);
            this.splitGuidesAndFaqs(articles);
        },
        splitGuidesAndFaqs(articles){
            articles.forEach(element => {
                switch(element.attributes.article_type){
                    case("article_type.guide"): this.guides.push(element.attributes); break;
                    case("article_type.faq"): this.faqs.push(element.attributes); break;
                }
            });
        }
    }
}
</script>
<style scoped>
    .grid{
        display: flex;
        flex-wrap: wrap;
        margin-right: -0.5rem;
        margin-left: -0.5rem;
        margin-top: -0.5rem;
    }

    .col-6{
        flex: 0 0 auto;
        padding: 1rem;
        width: 50%;
    }
    
</style>